import { Page } from '../../Page'
import { useEffect } from 'react';
import { useAppSelector, useAppDispatch } from '../../app/hooks';
import { 
    selectCurrentEventTaskTitle, 
    setTitle, 
    selectCurrentEventTaskTitleEmpty,
    setEventTitle, 
    selectCurrentEventTaskType,
    selectCurrentEventTaskAllocatedUserEmail,
    selectCurrentNotes,
    setAllocatedUserEmail,
    setNotes,
    selectCurrentEventTaskStatus,
    storeEventTaskAsync,
    setProgressionStatus,
    selectProgressionStatus
} from './currentEventTaskSlice'
import styles from './CurrentEventTask.module.css';
import { AdditionalFoodEventTaskInfo } from './AdditionalFoodEventTaskInfo'
import {AdditionalSendMoneyTaskInfo} from './AdditionalSendMoneyTaskInfo'
import { resetButtons, setBackButtonVisible, setSaveEventTaskVisible, setPromptOkCancelOnBack, setReloadButtonVisible, setHomeButtonVisible } from '../menu/menuSlice'
import { MessageBoxAction, setMessage, setMessageBoxAction } from '../messageBoxes/messageBoxSlice';
import { ClaimEventTaskButton } from './ClaimTaskButton';
import { useNavigate } from 'react-router-dom';
import { useAuth0 } from "@auth0/auth0-react"
import { loadEventUsersAsync, selectCurrentEventUsers } from '../currentEventUsers/currentEventUsersSlice';
import { selectCurrentPartyEvent, selectCurrentPartyLogoutRequested} from '../currentPartyEvent/currentPartyEventSlice';
import { sanitizeEmail } from '../../utils/emailUtils';
import { renderStatus } from '../../utils/enumUtils';
import { BackButton } from '../menu/BackButton';


export function EditEventTask() {
    const title = useAppSelector(selectCurrentEventTaskTitle)
    const titleEmpty = useAppSelector(selectCurrentEventTaskTitleEmpty)
    const currentEventTaskType = useAppSelector(selectCurrentEventTaskType)
    const currentEventUsers = useAppSelector(selectCurrentEventUsers)
    const currentPartyEvent = useAppSelector(selectCurrentPartyEvent)
    const currentAllocatedUserEmail = useAppSelector(selectCurrentEventTaskAllocatedUserEmail)
    const currentEventTaskStatus = useAppSelector(selectCurrentEventTaskStatus)
    const logoutRequested = useAppSelector(selectCurrentPartyLogoutRequested)
    const { isAuthenticated, getAccessTokenSilently, user } = useAuth0()
    const notes = useAppSelector(selectCurrentNotes)
    const progressionStatus = useAppSelector(selectProgressionStatus)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    useEffect(() => {
        dispatch(resetButtons())
        dispatch(setPromptOkCancelOnBack(true))
        dispatch(setBackButtonVisible(true))
        dispatch(setSaveEventTaskVisible(true))
        dispatch(setMessage('Cancel any changes made?'))
      }, [dispatch]);

      useEffect(() => {
        const getUserMetadata = async () => {
            if (isAuthenticated) {  
              try {
                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                }})
                  if (currentPartyEvent?.id) {
                      dispatch(loadEventUsersAsync({ 
                                      partyEventId: currentPartyEvent.id,
                                      token: accessToken
                                  }))
                  }
              } catch  {
                  console.log("Error occured getting token or getting event users");
              }
            }
            if (logoutRequested){
                navigate('/')
            }
          };
        
          getUserMetadata();

      }, [dispatch, getAccessTokenSilently, isAuthenticated, navigate, currentPartyEvent, logoutRequested]);
    return (
        <Page>
            <div className={styles.bannerContainer}>
                <div>
                <h2>PartyPlanner.</h2>
                <h4>Organise, invite and celebrate in style.</h4>
                </div>
                <br></br>
                <BackButton/>
            </div>
           <div className={styles.currentEventInfoPanel}>
                    <h2>Review task:</h2>
            </div>
            
            <label className={styles.label} htmlFor='txtTitle'>Title:</label>
            <input
                id='txtTitle'
                className={styles.textbox}
                aria-label='Set Title'
                value={title}
                onChange={(e) => dispatch(setTitle(e.target.value))}
            />
            {titleEmpty ? <p className={styles.validationMessage}>*You must give the task a title*</p> : null}
            <label className={styles.label} htmlFor='selectTaskType'>Task type:</label>
            <select
                id='selectTaskType'
                className={styles.dropdown}
                aria-label="Select Task Type"
                onChange={(e) => dispatch(setEventTitle(e.target.value))}
            >
                <option value={0}>Other Task</option>
                <option value={1}>Bring food task</option>
                <option value={2}>Pay money task</option>
            </select>
            { currentEventTaskType === 1 ? <AdditionalFoodEventTaskInfo/> : null }
            { currentEventTaskType === 2 ? <AdditionalSendMoneyTaskInfo/> : null}

            <label className={styles.label} htmlFor='txtAllocatedUserEmail'>Name:</label>
            <select
                     value={currentAllocatedUserEmail}
                     className={styles.dropdown}
                     onChange={(e) => {
                         dispatch(setAllocatedUserEmail(e.target.value)
                         )}}>
                <option value='' key={''}>Not selected yet</option>
            {isAuthenticated && currentEventUsers?.map((eventUser) => {
                return (
                 <option value={eventUser.email} className={styles.dropDown} key={eventUser.email}>
                    {eventUser.alias && eventUser.alias?.trim().length>0 ? eventUser.alias:eventUser.email }
                 </option>
                        
             )
            })}
            </select>
            <label className={styles.label} htmlFor='txtNotes'>Notes:</label>
            <input
                id='txtNotes'
                className={styles.textbox}
                aria-label='Set Notes'
                value={notes}
                onChange={(e) => dispatch(setNotes(e.target.value))}
            />
            
            <label className={styles.label} htmlFor='selectStatus'>Status:</label>
            <select 
                value={progressionStatus}
                id= 'selectStatus'     
                className={styles.dropdown}
                onChange={(e) => {
                    dispatch(setProgressionStatus(parseInt(e.target.value))
                    )}}>
                        <option value={0}>{renderStatus(0)}</option>
                        <option value={1}>{renderStatus(1)}</option>
                        <option value={2}>{renderStatus(2)}</option>
                        <option value={3}>{renderStatus(3)}</option>
                        </select>


            <ClaimEventTaskButton/>

            <br></br>
            <div className={styles.SaveCancelButtons}>
            <button className={styles.cancelButton} onClick={()=> {
                let msg3 = `Cancel any changes made to this task?`
                dispatch(setMessage(msg3))
                dispatch(setMessageBoxAction(MessageBoxAction.GoBack))
                navigate('/MessageBox')
            }}> Cancel</button>
            
            <button className={styles.SaveButton} onClick={async () => {
            if (isAuthenticated && user?.email) { 
                
                const accessToken = await getAccessTokenSilently({ authorizationParams : {
                }})
                    dispatch(storeEventTaskAsync( {
                        token: accessToken,
                        userEmail: sanitizeEmail(user?.email)
                        }))
                    if (currentEventTaskStatus === 'idle') {
                        navigate(-1)
                    } else {
                        alert (`Not expected status '${ currentEventTaskStatus }'`)
                    }
            }
        }}>
            Save
        </button>
        </div>
        <br></br>
        <br></br>
        <br></br>
        </Page>
    )
}